import { requests, ResponseType } from '../core';
import type { BannerResponse } from './types';

/**
 * 배너 API
 * GET /api/banner/main
 * GET /api/banner/bar
 */
export const bannerApi = {
  /**
   * 메인 배너 목록 조회
   * GET /api/banner/main
   * @returns 메인 배너 목록
   */
  getMainBanners: async (): Promise<ResponseType<BannerResponse[]>> => {
    return await requests.get<BannerResponse[]>('/api/banner/main', false);
  },
  /**
   * 헤더 띠배너 조회
   * GET /api/banner/bar
   * @returns 헤더 띠배너 데이터 (단일 객체)
   */
  getBarBanner: async (): Promise<ResponseType<BannerResponse>> => {
    return await requests.get<BannerResponse>('/api/banner/bar', false);
  },

  /**
   * 기획전 배너 조회
   * GET /api/banner/exhibition
   * @returns 기획전 상단 배너 목록
   */
  getExhibitionBanners: async (): Promise<ResponseType<BannerResponse[]>> => {
    return await requests.get<BannerResponse[]>('/api/banner/exhibition', false);
  },

  /**
   * 검색결과 배너 조회
   * GET /api/banner/search
   * @returns 노출 조건에 맞는 검색 결과 배너(단건) 조회 API
   */
  getSearchBanner: async (): Promise<ResponseType<BannerResponse[]>> => {
    return await requests.get<BannerResponse[]>('/api/banner/search', false);
  },

  /**
   * 프로모션 배너 목록 조회
   * GET /api/banner/promotion/{categoryId}
   * @param categoryId 프로모션 대메뉴 ID
   * @returns 프로모션 배너 목록
   */
  getPromotionBanners: async (categoryId: number): Promise<ResponseType<BannerResponse[]>> => {
    return await requests.get<BannerResponse[]>(`/api/banner/promotion/${categoryId}`, false);
  },
};

// 타입 재내보내기
export type { BannerListResponse, BannerResponse, UploadFileInfo } from './types';
